export default __webpack_public_path__ + "static/media/removed-icon.151db116.svg";